<template>
  <ion-page>
    <ion-content fullscreen />
    <ion-footer class="ion-padding footer-onboarding">
      <h1>
        {{ $t('onboarding.welcome') }} {{ user.customer.data.name }}
      </h1>
      <p v-if="user.customer.vehicles.length">
        {{ $t('onboarding.cars') }}
      </p>
      <p v-else>
        {{ $t('onboarding.no_cars') }}
      </p>
      <cars
        ref="cars"
        class="ion-no-margin ion-margin-top"
      >
        <template #default="{ add }">
          <ion-button
            v-if="$refs.cars"
            color="light"
            expand="block"
            @click="add"
          >
            <ion-icon
              slot="start"
              color="primary"
              :icon="addCircle"
            />
            {{ $t('cars.add_car') }}
          </ion-button>
        </template>
      </cars>

      <ion-button
        class="ion-margin-top"
        expand="block"
        @click="onboardingAgree"
      >
        {{ $t('onboarding.continue') }}
      </ion-button>

      <ion-grid class="ion-no-padding ion-margin-top-sm">
        <ion-row>
          <ion-col>
            <ul class="progress">
              <li />
              <li />
              <li />
              <li class="active" />
              <li />
            </ul>
          </ion-col>
          <ion-col class="ion-text-end">
            <ion-button
              fill="clear"
              color="medium"
              class="ion-no-margin ion-no-padding"
              @click="skip"
            >
              {{ $t('onboarding.skip') }}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-footer>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue';
import {
  IonFooter, modalController,
} from '@ionic/vue';
import {
  addCircle,
  removeCircle,
} from 'ionicons/icons';
import OnboardingAgree from '@/components/OnboardingAgree.vue';
import Cars from '@/components/Cars.vue';
import OnboardingMixin from '@/mixins/OnboardingMixin';

export default defineComponent({
  components: {
    Cars,
    IonFooter,
  },
  mixins: [OnboardingMixin],
  setup() {
    return {
      addCircle,
      removeCircle,
    };
  },
  methods: {
    /**
     * Go to onboarding agree.
     */
    async onboardingAgree() {
      await modalController.dismiss();

      const modal = await modalController.create({
        component: OnboardingAgree,
        showBackdrop: false,
        backdropDismiss: false,
      });
      await modal.present();
    },
  },
});
</script>

<style scoped>
ion-content {
  --background: none;
}
</style>
